/**
 * Async handler which runs in web worker
 * @private
 */
export default function run () {
  require('./worker')
}
